import React, { useState } from "react";
import {
  Card,
  Table,
  Row,
  Col,
  Form,
  Button,
  Container,
  Alert,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { addDays, getDay, getDate } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import moment from "moment";
import { Redirect } from "react-router-dom";
import _ from 'lodash';
import "bootstrap/dist/css/bootstrap.min.css";
import "./PanelResponse.css";
import api from "./api-endpoints.json";
import TimePicker from 'react-time-picker';
import { format } from 'date-fns';


const PanelResponse = (props) => {
  const [checkboxState, setCheckboxState] = useState(false);
  const [showReview, setShowReview] = useState(false);
  const [slotDate, setSlotDate] = useState(undefined);
  const [slotStartTime, setSlotStartTime] = useState(undefined);
  const [slotEndTime, setSlotEndTime] = useState(undefined);
  const [data, setData ] = useState([]);
  const [finalData, setFinalData ] = useState([]);
  const [validatedForm, setValidatedForm] = useState(false);
  const [alertMessageContent, setAlertMessageContent] = useState("");
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const [alertMessageContent2, setAlertMessageContent2] = useState("");
  const [showAlertMessage2, setShowAlertMessage2] = useState(false);
  const customDateFormat = 'dd/MM/yyyy';
  const customDateAndTimeFormat = 'dd/MM/yyyy kk:mm';
  
 
  const deleteAllTimeSlot = (e) => {
    data.map((entry, key)=> {
      if (entry.isSlected) {
          data.splice(key,1);

          finalData.map((val, index) =>{
              if(val.SlotDate ==entry.slotDate){
                  if( val.SlotInformation.length==1 ){
                    finalData.splice(index,1);
                   }else{
                    val.SlotInformation.map((slotVal, slotIndex) =>{
                      if(slotVal.slotStart==entry.slotStart && slotVal.slotEnd==entry.slotEnd){
                        val.SlotInformation.splice(slotIndex,1);
                      }
                    })
                  }
                }
              })
        }
      });

   setData([].concat(data));
   setFinalData([].concat(finalData));
};
      

    const slotInRange=(time)=> {
        return !(
         ( slotStartTime.replace(/:/g, "")<= time.slotStart.replace(/:/g, "") && slotEndTime.replace(/:/g, "") <= time.slotStart.replace(/:/g, ""))
          ||
          (slotStartTime.replace(/:/g, "")  >= time.slotEnd.replace(/:/g, "") && slotEndTime.replace(/:/g, "") >= time.slotEnd.replace(/:/g, ""))

          );
    }

const checkRecordAlreadyExists = () => {
  var flagSlotExists=false,flagDateExists=false;
  finalData.map((val, index) =>{
    
   if(val.SlotDate ==moment(slotDate).format("DD/MM/YYYY") ){
      flagDateExists=true;
            
      if(val.SlotInformation.filter(slotInRange).length>0){
        flagSlotExists=true;
      }else{
      var slotsJson={};
      slotsJson["slotStart"]=slotStartTime;
      slotsJson["slotEnd"] = slotEndTime;
      slotsJson["submittedTime"] = format(new Date(), customDateAndTimeFormat);
      val["SlotInformation"]=val["SlotInformation"].concat(slotsJson);

      var jsonData = {};
      jsonData["isSlected"] = false;
      jsonData["slotDate"] = moment(slotDate).format("DD/MM/YYYY");
      jsonData["slotStart"] = slotStartTime;
      jsonData["slotEnd"] = slotEndTime;
      setData(data.concat(jsonData));
      }
   }
  })
  return {flagDateExists,flagSlotExists};
}

const addTimeSlot = (e) => {
  let isValid = false,ifRecordAlreadyExists=false;
  setShowAlertMessage(false);
    setAlertMessageContent(
         "One or more errors detected while submitting. Please review and ensure all the details are filled correctly"
     );
    if (slotDate && slotStartTime  && slotEndTime){
    if(slotStartTime.replace(/:/g, "")<900 || slotStartTime.replace(/:/g, "")>1900 ){
      setAlertMessageContent("Slot start time should be in between 9am to 7pm only");
    }else if(slotEndTime.replace(/:/g, "")<900 || slotEndTime.replace(/:/g, "")>2100 ){
      setAlertMessageContent("Slot end time should be in between 9am to 9pm only");
    }else if(slotStartTime.replace(/:/g, "")>=slotEndTime.replace(/:/g, "")){
      setAlertMessageContent("Slot start time should always be less than slot end time");
    }else{
      ifRecordAlreadyExists=checkRecordAlreadyExists();
      if(ifRecordAlreadyExists.flagDateExists ){
        if(ifRecordAlreadyExists.flagSlotExists )
          setAlertMessageContent("Record already exists");
        }else{
          isValid = true;
        }
      }
  }

  if (isValid ) {

    var jsonData = {};

        jsonData["isSlected"] = false;
        jsonData["slotDate"] = moment(slotDate).format("DD/MM/YYYY");
        jsonData["slotStart"] = slotStartTime;
        jsonData["slotEnd"] = slotEndTime;
        setData(data.concat(jsonData));

        var finalJsonData={};

        finalJsonData["SlotDate"]=moment(slotDate).format("DD/MM/YYYY");
        finalJsonData["SlotInformation"]=[];
        var slotsJson={};
        slotsJson["slotStart"]=slotStartTime;
        slotsJson["slotEnd"] = slotEndTime;
        slotsJson["submittedTime"] = format(new Date(), customDateAndTimeFormat);

        finalJsonData["SlotInformation"]=finalJsonData["SlotInformation"].concat(slotsJson);
        setFinalData(finalData.concat(finalJsonData));
  }else{
    if(ifRecordAlreadyExists.flagDateExists && !ifRecordAlreadyExists.flagSlotExists)
      setShowAlertMessage(false);
    else
      setShowAlertMessage(true);
    }
};

  const isValidDate = (date) => {
    const day = getDay(date);

    if (
      getDate(date) === getDate(moment(new Date()).toDate()) + 1 ||
      getDate(date) === getDate(moment(new Date()).toDate())
    ) {
      return false;
    }
    //return day !== 0;
    return true;
  };

  const handleSubmit = async (event) => {
      event.preventDefault();
    if(finalData.length==0){
      setAlertMessageContent("Please add some records");
      setShowAlertMessage(true);
    }else
    {
      setAlertMessageContent("Please Wait, submitting");
      setShowAlertMessage(true);

     await axios({
        method: "post",
        url: api.ReceiveResponse,
        data: {
          PhoneNumber: props.phoneNumber,
          data: finalData,
        },
        config: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": true,
        },
      }).then((res) => {
        if (res.data === "Data Received") {
          setValidatedForm(true);
        }
      }).catch((err) => {
       console.log('err while submitting', err);
        setAlertMessageContent("Network err. Pls try later");
        setShowAlertMessage(true);

      });
      setShowAlertMessage2(false);
    }
  };

  const headerText = props.header.split('\n').map ((item, i) => <p key={i}>{item}</p>);
  const footerText = props.footer.split('\n').map ((item, i) => <p key={i}>{item}</p>);


  return (
      <div className="panelresponse-page-content">

      <div className="panelresponse-page-head">
        <img src={require("./logo.png")} alt="logo" />
                                <br/>
        <h4 className="panelresponse-page-subheading">Panelist Time Scheduling</h4>
      </div>
      <div className="panelresponse-page-body">
        <Form className="form-card">

            <React.Fragment>
              <Card className="information-card" >
                <Card.Body className="card-body-header">
                  <Card.Title as="h3">Hi, {props.name}</Card.Title>
                  <Card.Text className="text-left">{headerText}</Card.Text>
                </Card.Body>
              </Card>
              <Card>
                <Card.Body>
                  <Card.Title>Time Slot Preference</Card.Title>
                  <div className="preference-card">
                    <Card>
                      <Card.Body>
                        <div className="preference-card-title">
                          <Card.Title>Preference</Card.Title>
                        </div>
                        <Form.Group as={Row} controlId="formDate1 required">
                          <Form.Label column sm={4}>
                            Date
                          </Form.Label>
                          <Col sm={8}>
                            <DatePicker
                              className="date-pick"
                              selected={slotDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {setSlotDate(date);setShowAlertMessage(false);}}
                              maxDate={addDays(
                                moment(new Date()).toDate(),
                                22
                              )}
                              minDate={new Date()}
                              filterDate={isValidDate}
                              placeholderText="Select a date"
                              required={true}
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formTime1">
                          <Form.Label column sm={4}>
                           Start Time Slot
                          </Form.Label>
                          <Col sm={8}>
                            <TimePicker disableClock={true} onChange={(time) => {setSlotStartTime(time);    setShowAlertMessage(false);}}
                              hourPlaceholder="hh"
                              minutePlaceholder="mm"
                                format="H:m"
                              clearIcon={null}
                              /> (In 24 hr format)
                          </Col>
                        </Form.Group>
                         <Form.Group as={Row} controlId="formTime1">
                          <Form.Label column sm={4}>
                           End Time Slot
                          </Form.Label>
                          <Col sm={8}>
                            <TimePicker  disableClock={true} onChange={(time) => {setSlotEndTime(time);setShowAlertMessage(false);}}
                              hourPlaceholder="hh"
                              minutePlaceholder="mm"
                              format="H:m"
                              clearIcon={null}
                              /> (In 24 hr format)
                          </Col>
                        </Form.Group>
                      </Card.Body>
                    </Card>
                  </div>
                 
                 
                </Card.Body>
              </Card>
              
              <Alert
                className="form-alert"
                show={showAlertMessage}
                variant="danger"
              >
                {alertMessageContent}
              </Alert>
              <Button
       
                className="review-btn"
                variant="primary"
                onClick={addTimeSlot}
              >
                          Add
              </Button>
                     
            </React.Fragment>
          
            <React.Fragment>
              <Card className="review-card">
                <Card.Title className="review-card-title">
                  Review Details
                </Card.Title>
                <Card.Body>
                  <Table responsive borderless className="table-responsive-sm">
                    <thead>
                      <tr>
                      <th></th>
                        <th>Preference</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th></th>
                      </tr>
                    </thead>
                      <tbody>
                      
                      {data.map((row,i)=>{
                          return (<tr key={i}>
                        <td><input type="checkbox" defaultChecked={row.isSlected}
                                    onClick={(event) => {row.isSlected=event.target.checked}}  />
                        </td>   
                        <td>{row.slotDate}</td>
                        <td>{row.slotStart}</td>
                        <td>{row.slotEnd}</td>
                      </tr>);
                       })}
                      </tbody>
                     
                              </Table>
                              <Button onClick={deleteAllTimeSlot}>Delete</Button>
                </Card.Body>

                     <Button onClick={handleSubmit}>Submit</Button>
              </Card>
              <Card className="information-card-2">
                <Card.Title className="review-card-title">Important</Card.Title>
                <Card.Body>
                    <Card.Text className="text-left" >{footerText}</Card.Text>
                </Card.Body>
                <Form.Group controlId="formBasicCheckbox" required></Form.Group>
              </Card>
              <Alert
                className="form-alert-2"
                show={showAlertMessage2}
                variant="warning"
              >
                {alertMessageContent2}
              </Alert>
             
            </React.Fragment>
          
        </Form>
        {validatedForm && <Redirect to="/thankyou"></Redirect>}
      </div>
    </div>
  );
};



export default PanelResponse;